@if (isDataArrived) {
  <div class="saveSearchCriteriaContainerWrap">
    <!-- delete confirmation dialog -->
    <his-confirm-dialog></his-confirm-dialog>
    <div class="saveSearchCriteriaContainer">
      <div class="saveSearchCriteriaColumnLeft">
        @if (!isShowSelectField && !isShowAddView) {
          <button
            (click)="addSearchCriteriaSet()"
            class="addSearchCriteriaSet">
            <span>{{ 'genericSearch.searchCriteriaSets.saveCriteria' | hisUi }}</span>
          </button>
        }
        @if (isShowAddView) {
          <his-plam
            label="{{ 'genericSearch.searchCriteriaSet.name.title' | hisUi }}">
            <input #content [(ngModel)]="newSearchCriteriaSetName" required
              (keydown.enter)="saveSearchCriteriaSet(); $event.preventDefault();">
          </his-plam>
        }
        <!-- genericSearch.searchCriteriaSet.name.title = Name -->
        <!-- label="#{messages['genericSearch.searchCriteriaSets.title']} auswählen" -->
        @if (isShowSelectField) {
          <his-plam
            label="{{ 'genericSearch.searchCriteriaSets.choose' | hisUi }}"
            styleClass="verticalAlignMiddle input_standard">
            <p-autoComplete #content
              #autocomplete
              [(ngModel)]="selectedSearchSet"
              optionLabel="defaulttext"
              [suggestions]="currentSearchCriteriaSets"
              [dropdown]="true"
              (completeMethod)="completeMethod($event)"
              (onSelect)="onSelect($event)"
              (onClear)="onClear()">
            </p-autoComplete>
          </his-plam>
        }
      </div>
      <div class="saveSearchCriteriaColumnRight">
        <!-- 	Suchset hinzufügen  -->
        @if (isShowAddLink) {
          <button (click)="addSearchCriteriaSet()" 
            hisImage="plus_circ">
          </button>
        }
        <!-- 	hier die Icons -->
        <!-- 	Speichern -->
        @if (isShowSaveIcon) {
          <button (click)="saveSearchCriteriaSet()" 
            hisImage="save" 
          [title]="'genericSearch.searchCriteriaSets.saveSearchSet' | hisUi"></button>
        }
        <!--     Abbrechen -->
        @if (isShowAddView) {
          <button (click)="cancel()" 
            hisImage="panel_close" 
          [title]="'common.cancel' | hisUi"></button>
        }
        <!--     Als Standard setzen -->
        @if (isShowSetStandardIcon) {
          <button (click)="setAsStandard()" 
            hisImage="star" 
          [title]="'genericSearch.searchCriteriaSet.setAsDefault' | hisUi"></button>
        }
        <!--     Als Normal setzen -->
        @if (isShowResetStandardIcon) {
          <button (click)="resetStandard()" 
            hisImage="star_delete" 
          [title]="'genericSearch.searchCriteriaSet.disableAsDefault' | hisUi"></button>
        }
        <!-- 	Suchset löschen  -->
        @if (isShowDeleteIcon) {
          <button (click)="delete()" hisImage="delete"
            
          [title]="'genericSearch.searchCriteriaSets.deleteSearchSet' | hisUi"></button>
        }
        <!-- 	Suchset hinzufügen  -->
        @if (isShowAddIcon) {
          <button (click)="addSearchCriteriaSet()"
            hisImage="plus_circ" 
          [title]="'genericSearch.searchCriteriaSets.newSet' | hisUi"></button>
        }
      </div>
      <div class="clearer"></div>
    </div>
  </div>
}
